import { AfterViewChecked, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FormBuilder } from '@angular/forms';
import { EncriptyUtilService } from '../../../../shared/services/encripty-util.service';
import { NbDialogService } from '@nebular/theme';
import { DetalhePedidoService } from './detalhe-pedido.service';
import { NotificationsService } from 'angular2-notifications';
import { HttpParams } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { DocumentoHelper } from '../../../../shared/utils/documento.helper';
import { ModalRecebiveisCercComponent } from './modal-recebiveis-cerc/modal-recebiveis-cerc.component';

@Component({
  selector: 'ngx-detalhe-pedido',
  templateUrl: './detalhe-pedido.component.html',
  styleUrls: ['./detalhe-pedido.component.scss']
})
export class DetalhePedidoComponent implements OnInit, AfterViewChecked {

  // @ViewChild('recebiveisMes') recebiveisMes;

  public formDetalheVenda = null;
  public formNotaFiscal = null;
  public listParecer = null;
  public listFornecedor: any = [];
  public empresaSolicitante = null;
  public cnpj = null;
  public valor = null;
  public dadoNotaFiscal = false;
  public rowData = null;
  public totalAmount = false;
  public receivables_less_30 = null;      //créditos menos 30
  public receivables_greater_30 = null;  //recebíveis maiores 30
  public payment_account = null;        //conta de pagamento
  public valorRecebiveis = null;
  public saldoOneradoEfeito = null;
  public contaPagto = null;
  public importId = null;
  public creditoTotal = null;
  public pedidoVendaId = null;
  public statusParecerComprador = null;
  public creditoAprovadoMenor30Dias = null;
  public creditoAprovadoMaior30Dias = null;
  public saldoTransacoesFuturas = null;
  public creditosContaCorrente = null;
  public recebiveisMenor30Dias = null;
  public saldoCerc = null;
  public saldoTotalCerc = null;
  public recebiveisMaior30Dias = null;
  public desabilitaCheckMaior30Dias = null;
  public desabilitaCheckMenor30Dias = null;
  public cnpjFinalNota = null;
  public isDisabledSaveButton: boolean = true;
  public saldoAgilli = null;
  public saldoOutros = null;
  public saldoMenor = null;
  public valorCerc = null;
  public cnpjRecebedor = null;
  public isTermo = null;
  public isSaldoCredenciadora = null;
  public isAprovar = false;
  public valorTotal: number;
  public paramsTermo = null;
  public cnpjCpfLido = null;
  public saldoTotal: number;
  public isSimuleValor = false;
  public valoresRecebiveis = null;
  public customLogin = null;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private encriptyService: EncriptyUtilService,
    private dialogService: NbDialogService,
    private service: DetalhePedidoService,
    private notificationService: NotificationsService,
    private cdRef: ChangeDetectorRef,
    private spinnerService: NgxSpinnerService,

  ) {

    this.valorRecebiveis = 0;
    this.creditosContaCorrente = 0;
    //this.saldoTransacoesFuturas = 0;
    //this.saldoCerc = 0;
    //this.saldoOneradoEfeito = 0;
    //this.isDisabledSaveButton = true;

    this.service.balanceDetailViewList(null, (response) => {

      this.totalAmount = response.totalAmount

      for (let recebivel of response.balanceDetailViewList) {
        if (recebivel.type === 'payment_account') {
          this.creditosContaCorrente = recebivel.amount;
        } else if (recebivel.type === 'encumbered_balance') {
          this.saldoOneradoEfeito = recebivel.amount;
        }
      }

     /* this.saldoTotal = Number(this.valorRecebiveis) + Number(this.creditosContaCorrente);

      if (this.paramsTermo === 'termo') {
        document.getElementById('termo').setAttribute('checked', 'true');
        this.isDisabledSaveButton = false;
        //this.isAprovar = true;
        this.isTermo = true
      } else if (this.saldoTotal > this.valorTotal) {
        //this.isDisabledSaveButton = true;
        //this.isAprovar = true;
        this.isTermo = false
      } else if (this.saldoTotal < this.valorTotal) {
        //this.isAprovar = true;
        //this.isTermo = true;
        this.notificationService.error("Saldo insuficiente!");

      }*/

    }, (error) => this.notificationService.error("Não foi posssível carregar Saldo!"))

    this.activatedRoute.queryParams.subscribe(params => {

      this.paramsTermo = params.tela;
      this.statusParecerComprador = params.statusPedido;

      this.service.moreDetails(params, (response) => {

        this.cnpjCpfLido = response.cnpjVendedor;
        this.cnpj = this.cnpjCpfLido;
        this.valorTotal = response.valor;
        this.formDetalheVenda.controls['razaoSocial'].setValue(response.empresaVendedor);
        this.formDetalheVenda.controls['cnpj'].setValue(this.formatarDocumento(this.cnpjCpfLido));
        this.formDetalheVenda.controls['valor'].setValue(response.valor);
        this.formDetalheVenda.controls['descricao'].setValue(response.detalhesPedido);
        this.creditoTotal = response.valor;
        this.pedidoVendaId = response.id;

      }, null)

    });

    this.service.balanceValorRecebiveis(null, (response) => {

      this.valorRecebiveis = response.valorLiquidoDisponivel;

    }, (error) => this.notificationService.error('Não foi possível obter informações de saldo.'))

    this.listParecer = [

      {
        status: 'APROVADO',
        descricao: 'APROVAR'
      },

      {
        status: 'REJEITADO',
        descricao: 'REPROVAR'
      },

    ];

    this.formDetalheVenda = this.formBuilder.group({
      razaoSocial: [null],
      cnpj: [null],
      valor: [null],
      descricao: [null],
      observacao: [null],
      parecer: [null],
      listaFornecedor: [null],
      valorOnline: [null],
      recebiveisMes: [null],
      recebiveisParcelados: [null],
      termo: [null],
      valorLiquido: [null],
      valorSimulado: [null],
      valorTaxas:[null],

    });

    this.cnpjRecebedor = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-enterprise-federal-id'));

    this.buscaSaldoCerc(this.cnpjRecebedor);

  }

  ngOnInit() {
    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
  }

  aceiteTermo() {

    let saldoInsuficiente = Number(this.valorRecebiveis) + Number(this.creditosContaCorrente) + Number(this.saldoCerc)

    if (saldoInsuficiente < this.creditoTotal) {
      this.isDisabledSaveButton = true;
      this.dadoNotaFiscal = false;
      this.notificationService.error("Saldo insuficiente!");

    } else {

      let id = this.encriptyService.encriptyBySecretKey('' + this.pedidoVendaId);

      let saldoCerc = Number(this.valorTotal) - Number(this.saldoTotal);

      const cnpjLidoNorm = this.normalizarCnpjCpfParaBackend(this.cnpjCpfLido);
      const cnpjRecebNorm = this.normalizarCnpjCpfParaBackend(this.cnpjRecebedor);
      let params = {
        'id': id,
        'cnpjCpfLido': this.encriptyService.encriptyBySecretKey('' + cnpjLidoNorm),
        'cnpjCpfRecebedor': this.encriptyService.encriptyBySecretKey('' + cnpjRecebNorm),
        'valor': this.encriptyService.encriptyBySecretKey('' + saldoCerc.toFixed(2)),
      }

      this.router.navigate(['../termo-condicao'], { relativeTo: this.activatedRoute, queryParams: params });

    }

  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  listaFornecedor(data) {

    this.cnpjFinalNota = data;

  }

  aprovarParecer(data) {

    this.isDisabledSaveButton = false;

    if (data === 'REJEITADO') {

      this.formDetalheVenda.controls['valorSimulado'].setValue(null);
      this.formDetalheVenda.controls['valorLiquido'].setValue(null);
      this.formDetalheVenda.controls['valorTaxas'].setValue(null);

    }

    /*if (data === 'APROVADO') {

      //let saldoInsuficiente = Number(this.valorRecebiveis) + Number(this.creditosContaCorrente);

      //this.dadoNotaFiscal = true
     /* this.service.listSupplier(null, (response) => {
        this.listFornecedor = response
      }, (error) => this.notificationService.error("Não foi posssível carregar a lista de Fornecedores!"))

      if (saldoInsuficiente < this.creditoTotal) {
        this.isDisabledSaveButton = true;
        //this.dadoNotaFiscal = false;
        this.notificationService.error("Saldo insuficiente!");

      }else {
        this.isDisabledSaveButton = false;
      } else {

        this.isDisabledSaveButton = false;
        this.service.listSupplier(null, (response) => {
          this.listFornecedor = response
        }, (error) => this.notificationService.error("Não foi posssível carregar a lista de Fornecedores!"))

        let saldoTotal = Number(this.creditosMaiores) + Number(this.creditosMenor) + Number(this.creditosContaCorrente);
        let saldoCredito = Number(this.creditosMaiores) + Number(this.creditosMenor);

        if (saldoTotal >= this.creditoTotal) {

          this.dadoNotaFiscal = true;
          if (this.creditosMenor >= this.creditoTotal) { // Credito Total é maior que Recebiveis menor que 30.

            this.creditoAprovadoMenor30Dias = this.creditoTotal;

          } else if (this.creditosMaiores >= this.creditoTotal) {// Credito Recebiveis menor credito total.

            this.creditoAprovadoMenor30Dias = this.creditosMenor;
            this.creditoAprovadoMaior30Dias = this.creditoTotal - this.creditosMenor

          } else if (saldoCredito >= this.creditoTotal) {

            this.creditoAprovadoMenor30Dias = this.creditosMenor;
            this.creditoAprovadoMaior30Dias = this.creditoTotal - this.creditosMenor

          } else {// Pega da conta corrente.

            this.creditoAprovadoMenor30Dias = this.creditosMenor;
            this.creditoAprovadoMaior30Dias = this.creditosMaiores;

          }

        } else {

          this.dadoNotaFiscal = true;
          this.saldoAgilli = Number(this.creditosMaiores) + Number(this.creditosMenor) + Number(this.creditosContaCorrente);
          this.saldoTotalCerc = Number(this.creditoTotal) - Number(this.saldoAgilli);
          this.valorCerc = parseFloat((this.saldoTotalCerc).toFixed(2));
          this.creditoAprovadoMenor30Dias = this.creditosMenor;
          this.creditoAprovadoMaior30Dias = this.creditosMaiores;

        }

      }

    } else {
      //this.dadoNotaFiscal = false;
      this.isDisabledSaveButton = false;
    }*/

  }

  buscaModal() {

    this.spinnerService.show();

    setTimeout(() => {

      this.spinnerService.hide();
      this.cdRef.detectChanges();
      this.dialogService.open(ModalRecebiveisCercComponent, {
        hasBackdrop: false,
      }).onClose.subscribe(validacao => this.habillitarBotao(validacao));

    }, 5000);

  }

  habillitarBotao(value: boolean) {
    if (value) {
      this.isDisabledSaveButton = false;
      this.dadoNotaFiscal = true;
    }
  }

  salvePedidoVenda(data) {

    let register = {

      observacaoComprador: data.observacao,
      pedidoVendaId: this.pedidoVendaId,
      valoresRecebiveis: this.valoresRecebiveis != null ? this.valoresRecebiveis : 0,
      saldoCerc: this.valorCerc,
      statusParecerComprador: data.parecer,

    }

    if (data.parecer === 'APROVADO') {
      this.spinnerService.show();
      this.service.approvesOnlineSale(
        register,
        (resp) => {
          this.spinnerService.hide();
          this.notificationService.success('Registro Salvo com sucesso!');
          this.router.navigate(['/pages/compra-online/consulta-pedido-recebido']);

        }, (error) => {
          this.spinnerService.hide();
          this.isDisabledSaveButton = false;
          this.notificationService.error(error.message);
        })

    } else {
      this.spinnerService.show();
      this.service.approvesOnlineSale(
        register,
        (resp) => {
          this.spinnerService.hide();
          this.notificationService.success('Registro Reprovado com sucesso!');
          this.location.back();
        }, (error) => {
          this.spinnerService.hide();
          this.notificationService.error(error.message);
        })

    }

  }

  limparForm() {
    this.formDetalheVenda = this.formBuilder.group({

      observacao: [null],
      parecer: [null],

    });

  }

  buscaSaldoCerc(data) {

    let params = new HttpParams();

    if (data != null && String(data).trim() !== '') {
      params = params.append('cnpjCpfReceiver', this.normalizarCnpjCpfParaBackend(data));
    }

    this.service.receivablesCerc(params, (response) => {

      this.saldoCerc = response.somaRecebiveisCerc;

      if (this.saldoCerc === 0) {
        this.isTermo = false;
        this.isSaldoCredenciadora = false;
      } else {
        this.isTermo = true;
        this.isSaldoCredenciadora = true;
      }

    }, null)

  }

  viewdiv(data){

    this.formDetalheVenda.controls['valorSimulado'].setValue(null);
    this.formDetalheVenda.controls['valorLiquido'].setValue(null);
    this.formDetalheVenda.controls['valorTaxas'].setValue(null);
    this.formDetalheVenda.controls['parecer'].setValue('SELECIONE');

    if(data == 'sim'){

      this.isSimuleValor = true;
      this.isAprovar = false;
      this.isDisabledSaveButton = true;

    }else{
      this.valoresRecebiveis = 0;
      this.isSimuleValor = false;
      this.isDisabledSaveButton = true;

      if(this.creditoTotal > this.creditosContaCorrente ){
        this.isAprovar = false;
        this.notificationService.error("Saldo insuficiente!");
      }else{
        this.isAprovar = true;
      }

    }
  }

  simuleValor(data){

     let params = new HttpParams();
     let valorTotal = Number(this.valorRecebiveis) + Number(this.creditosContaCorrente)
     this.formDetalheVenda.controls['parecer'].setValue('SELECIONE');

    if (data.valorSimulado != null) {
      params = params.append('valorOperacao', data.valorSimulado)
    }

    if(data.valorSimulado == 0){

      this.notificationService.error("Não é permitido simular valor 0!");

    }else{

      if(data.valorSimulado > this.valorRecebiveis){

        this.notificationService.error("Valor simulado maior que o recebíveis.");
        this.formDetalheVenda.controls['valorSimulado'].setValue(null);
        this.formDetalheVenda.controls['valorLiquido'].setValue(null);
        this.formDetalheVenda.controls['valorTaxas'].setValue(null);

      }else if(data.valorSimulado <= this.creditoTotal){

        if(valorTotal < this.creditoTotal){
          this.notificationService.error("Valor do pedido maior que saldos em conta!");
        }else{

          this.spinnerService.show();

          this.service.simulateRetailOnline(params, (response) => {

          this.valoresRecebiveis = response.valorLiquidoDisponivel;
          this.formDetalheVenda.controls['valorLiquido'].setValue(this.valoresRecebiveis);
          this.formDetalheVenda.controls['valorTaxas'].setValue(response.valorTotalTaxas);
          this.spinnerService.hide();
          this.isAprovar = true;

         }, (error) => {
           this.spinnerService.hide();
           this.notificationService.error(error.message);
         })

        }

      }else{

        this.notificationService.error("Não é possível simular valor maior que o valor do pedido.");
        this.formDetalheVenda.controls['valorSimulado'].setValue(null);
        this.formDetalheVenda.controls['valorLiquido'].setValue(null);
        this.formDetalheVenda.controls['valorTaxas'].setValue(null);

      }

    }

  }

  showCardModal() {

    this.router.navigate(['/pages/compra-online/cadastrar-fornecedor']);

  }

  previousPage() {
    this.location.back();
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

  getCpfCnpjMask(): string {
    const ctrl = this.formDetalheVenda && this.formDetalheVenda.get('cnpj');
    const doForm = ctrl ? ctrl.value : null;
    const raw =
      this.cnpj != null && String(this.cnpj).trim() !== ''
        ? this.cnpj
        : doForm;
    return DocumentoHelper.getMascaraCpfCnpj(raw);
  }

  formatarDocumento(valor: string | null | undefined): string {
    return DocumentoHelper.formatarDocumento(valor);
  }

  private normalizarCnpjCpfParaBackend(value: any): string {
    if (value == null) return '';
    const str = String(value);
    if (str === '') return '';
    const tipo = DocumentoHelper.detectarTipoDocumento(str);
    return DocumentoHelper.normalizarParaEnvio(str, tipo);
  }
}
